/* ============================================================
   Rebuy Smart Cart — theme cart-drawer suppression layer (site-wide).

   Problem: with the Rebuy Smart Cart app embed active, an add-to-cart
   opened BOTH cart UIs — Rebuy's flyout on top of the theme's drawer
   (closing the flyout revealed the theme drawer still open behind it).

   Behavior: once the Rebuy SDK is confirmed available, the theme
   drawer is neutralized — its open/close toggles become no-ops (the
   drawer's hidden content + the cart icon bubble still re-render, so
   counts stay fresh) and the header cart trigger opens the Smart Cart
   instead. ADAPTIVE: if Rebuy never loads (app removed/blocked), this
   script does nothing and the theme drawer keeps working as before.
   Remove this asset + its theme.liquid script tag if Rebuy is ever
   uninstalled permanently.
   ============================================================ */
(function () {
  'use strict';
  var patched = false;

  function smartCartVisible() {
    var el = document.getElementById('rebuy-cart');
    return !!(el && el.classList.contains('is-visible'));
  }

  function openSmartCart() {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    if (sc && typeof sc.show === 'function') {
      if (!smartCartVisible()) { try { sc.show(); } catch (e) {} }
      return true;
    }
    return false;
  }

  function patch() {
    if (patched) return;
    patched = true;

    // CSS belt-and-braces: drawer + its page overlay can never display
    // while Rebuy is active, even if some code path re-adds open classes.
    document.documentElement.classList.add('rebuy-cart-active');
    var st = document.createElement('style');
    st.textContent = 'html.rebuy-cart-active .wt-cart__drawer,html.rebuy-cart-active .page-overlay-cart{display:none!important}';
    document.head.appendChild(st);

    var cd = document.querySelector('cart-drawer');
    if (cd) {
      // clear any drawer that opened before Rebuy finished booting
      try {
        cd.removeAttribute('open');
        cd.isOpen = false;
        var drawer = cd.querySelector('.wt-cart__drawer');
        if (drawer) drawer.classList.remove('wt-cart__drawer--open');
        document.body.classList.remove('page-overlay-cart-on');
      } catch (e) {}
      // theme add-to-cart + trigger paths route through these — no-op them.
      // (renderContents still updates drawer content + cart icon bubble.)
      cd.toggleDrawerClasses = function () {};
      cd.onToggle = function () {};
    }

    // Cart triggers (header icon etc.) open the Smart Cart; if the SDK
    // disappears mid-session, fall through to the /cart page.
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.wt-cart__trigger, .wt-cart__back-link');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      if (!openSmartCart()) window.location.href = '/cart';
    }, true);
  }

  // Activate only once Rebuy is genuinely available — never break carts.
  var tries = 0;
  (function poll() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') { patch(); return; }
    if (++tries < 120) setTimeout(poll, 500); // keep checking for ~60s
  })();
})();
